export default {
  dashboard: "Painel",
  maxLimit:"O limite máximo não deve ser maior que seis dígitos.",
  emptyDeforestationStatus: "O status de desmatamento do EUDR está vazio.",
  areYouSureText: "Tem certeza de que deseja realizar esta ação?",
  phoneNumber: "Número de telefone",
  farmSize: "Tamanho da Fazenda",
  farmName: "Nome da Fazenda",
  farmLocation: "Fazenda/Localização",
  technicianName: "Nome do Técnico",	
  addFarm: "Adicionar Fazenda",
  used: "Usado",
  importFarmsInBulk: "Importar Fazendas em Lote",
  approved: "Aprovado",
  rejected: "Rejeitado",
  pending: "Pendente",
  "all": "Todas",
  "Day/s": "Dia/s",
  "Week/s": "Semana/s",
  "Month/s": "Mês/s",
  "Year/s": "Ano/s",
  january: "Janeiro",
  february: "Fevereiro",
  march: "Março",
  april: "Abril",
  may: "Maio",
  june: "Junho",
  july: "Julho",
  august: "Agosto",
  september: "Setembro",
  october: "Outubro",
  november: "Novembro",
  december: "Dezembro",
  Carbon: "Carbono",
  Potassium: "Potássio",
  Phosphorus: "Fósforo",
  Nitrogen: "Azoto",
  Sulfur: "Enxofre",
  version: "Versão",
  psw: "Senha",
  read: "Lidas",
  unread: "Não Lidas",
  reset: "Reiniciar",
  'Due Diligence Reports': "Relatório de Devida Diligência",
  'EUDR Deforestation Assessments': "Avaliações de Desmatamento EUDR",
  'Risk Assessments': "Avaliação de Risco",
  Used: "Usado",
  topFive: "5 principais",
  confPsw: "Confirme a senha",
  newPsw: "Nova Senha",
  email: "E-mail",
  emailId: "ID do E-mail",
  submit: "Enviar",
  cancel: "Cancelar",
  faqs: "Perguntas frequentes",
  id: "ID",
  of: "de",
  warehouse: "Armazém",
  price: "Preço",
  processor: "Processador",
  cuppingScore: "Pontuação de Prova",
  label: "Etiqueta",
  expiry: "Validade",
  users: "Usuários",
  appUser: "Usuários do App",
  app_users: "Usuários do App",
  dimitraAdmin: "Administrador Dimitra",
  admin_users: "Usuários Admin",
  search: "Buscar",
  searchByProducerName: "Pesquisar pelo nome do produto",
  searchBy: "Buscar {type}",
  firstName: "Nome",
  lastName: "Sobrenome",
  mobile: "Celular",
  mobileNumber: "Número de Celular",
  department: "Departamento",
  role: "Perfil",
  status: "Status",
  autoCondition: "Condição automática",
  permission: "Permissões",
  activity_log: "Registro de Atividades",
  profile_auth: "Configuração de Autenticação de Perfil",
  countryCode: "Código País",
  selectDept: "Selecione o Departamento",
  selectRole: "Selecionar Perfil",
  edit: "Editar",
  update: "Atualizar",
  delete: "Deletar",
  view: "Ver",
  deactivate: "Inativar",
  activate: "Ativar",
  serverError: "Algo deu errado. Por favro tente novamente mais tade.",
  minute: "Minuto",
  perHour: "Por hora",
  day: "Dia",
  enterDescription: "Digite sua descrição aqui",
  enterHere: "Insira aqui",
  enterMobile: "Insira o número de celular",
  phoneRequired: "Celular é obrigatório",
  phoneValid: "Insira um número válido",
  unableToUpdate: "Não foi possível atualizar",
  membershipPlans: "Planos de associação",
  byWeek: "Por semana",
  byMonth: "Por mês",
  byYear: "Por ano",
  custom: "Personalizado",
  name: "Nome",
  regionState: "Região/Estado",
  provinceState: "Província/Estado",
  cityTown: "Cidade",
  village: "Aldeia",
  membershipValidity: "Validade da associação",
  exportAsCSV: "Exportar como CSV",
  filterBy: "Filtrar por",
  comingSoon: "Em Breve",
  userRole: "Papel do usuário",
  additionalInformationRequired: "Informações Adicionais Necessárias",
  approve: "Aprovar",
  reject: "Rejeitar",
  username: "Nome de usuário",
  phone: "Celular",
  roleAssigned: "Função atribuída",
  roleRequested: "Função solicitada",
  requestedDate: "Data de solicitação",
  updateRoleRequest: "Atualizar solicitação de função",
  message: "mensagem",
  selectFileToUpload: "Selecione o arquivo para enviar dados",
  totalRecords: "Total de registros",
  success: "Sucesso",
  recordsImported: "Registros importados",
  deleted: "Excluído com sucesso",
  failed: "Falhou",
  fermentation: "Fermentação",
  language: "Idioma",
  offline_users: "Usuários Offline",
  departmentName: "Nome do Departamento",
  basicPlanValidity: "Validade do Plano Básico",
  membershipExpiryDate: "Data de Expiração da Associação",
  extendedValidity: "Validade Estendida",
  conditional: "Condicional",
  addUserRole: "Adicionar Função do Usuário",
  editUserRole: "Editar Função do Usuário",
  back: "Voltar",
  browse: "Procurar",
  clearAll: "LIMPAR TUDO",
  filterByRegion: "Filtrar por Região",
  continue: "Continuar",
  resolveNow: "Resolver Agora",
  description: "Descrição",
  selectWeek: "Selecionar Semana",
  hideSplash: "Ocultar Splash?",
  hideLogo: "Ocultar Logo?",
  confirm: "CONFIRMAR",
  selectMonth: "Selecionar Mês",
  selectDateRange: "Selecionar Intervalo de Datas",
  regionDistrict: "Região/Distrito",
  address: "Endereço",
  familyTribe: "Tribo da Família",
  website: "Site",
  deactivated: "Desativado",
  active: "Ativo",
  inactive: "Inativo",
  country: "País",
  state: "Estado",
  farmer: "Agricultor",
  commodity: "Mercadoria",
  quantity: "Quantidade",
  unit: "Unidade",
  save: "SALVAR",
  remove: "Remover",
  stateIsReq: "Estado é obrigatório",
  cityIsReq: "Cidade é obrigatória",
  addressIsReq: "Endereço é obrigatório",
  membershipTypeReq: "Tipo de associação é obrigatório",
  extendedReasonReq: "Motivo da extensão é obrigatório",
  numberOfDaysReq: "Número de dias é obrigatório",
  extendedMembershipValidity: "Validade Estendida da Associação",
  set: "CONFIGURAR",
  adminRole: "Função de Administrador",
  typeMsg: "Digite sua mensagem aqui",
  mile: "Milha",
  manageFarmer: "Gerenciar Agricultor",
  manageOfflineFarmers: "Gerenciar Agricultores Offline",
  dashboardSettings: "Configurações do Painel",
  done: "Concluído",
  noRecordFound: "Nenhum registro encontrado",
  farmerName: "Nome do Agricultor",
  production: "Produção",
  registered: "Registrado",
  downloadForReport: "BAIXAR RELATÓRIO PDF",
  downloadPdfReport: "Baixar Relatório PDF",
  notifications: "Notificações",
  markAllAsRead: "Marcar Todas Como Lidas",
  viewNotifications: "Ver Notificações",
  youAreUpToDate: "Você está atualizado",
  sendNotifications: "Enviar Notificações",
  createNotification: "Criar Notificação",
  viewAllNotifications: "Ver todas as Notificações",
  createNotificationForGroup: "Criar Notificação para o Grupo/Vários Usuários",
  createNotificationForDimitra: "Criar Notificação para o Administrador Dimitra",
  pleaseCheckTickMark: "Por favor, marque a marca para adicionar o usuário na lista",
  clearAllFilters: "Limpar todos os filtros",
  note: "*Nota: Apenas arquivos Mp4 são suportados para vídeo",
  validMemberships: "Associações Válidas",
  memberShipPlanMessage:
    "Tem certeza de que deseja excluir este plano de associação?",
  deleteMemberShipPlan: "Excluir Plano de Associação",
  systemAutoLogout: "O sistema será desconectado automaticamente em 2 minutos",
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  Wednesday: "Quarta-feira",
  thursday: "Quinta-feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  sunday: "Domingo",
  warning: "Aviso",
  meter: "Metro",
  kiloMeter: "Quilômetro",
  miles: "Milhas",
  gram: "Grama",
  kilogram: "Quilograma",
  pound: "Libra",
  cubicKilo: "Quilômetro Cúbico (km³)",
  cubicMeter: "Metro Cúbico (m³)",
  cubicCentimeter: "Centímetro Cúbico (cm³)",
  cubicMilimeter: "Milímetro Cúbico (mm³)",
  showingAll: "Mostrando tudo",
  addnewOfflineFarmer: "Adicionar novo agricultor offline",
  export: "Exportar",
  exportAs: "Exportar como",
  createNewOfflineFarmer: "Criar novo agricultor offline",
  offlineFarmerForByingStationOnly:
    "Agricultor offline apenas para estação de compra (Local)",
  offlineFarmerForAllByingStations:
    "Agricultor offline para todas as estações de compra (Global)",
  noDataAvailable: "Nenhum dado disponível",
  buyingStation: "Estação de Compra",
  dryMillingStation: "Estação de Moagem a Seco",
  mergeWithExistingAccount: "Mesclar com uma conta existente",
  createNewAccount: "Criar nova conta",
  mobileOrEmailRequiredForRegister:
    "Para registrar o aplicativo, pelo menos um detalhe deve ser fornecido, seja número de celular ou e-mail.",
  selectLanguage: "Selecionar idioma",
  basicPlan: "Plano Básico",
  local: "Local",
  newUser: "Novo Usuário",
  merged: "Mesclado",
  global: "Global",
  qrcode: "Código QR",
  emailSentSuccessfully: "Email enviado com sucesso",
  somethingWentWrong: "Algo deu errado",
  select: "Selecionar",
  goBack: "Voltar",
  farms: "Fazendas",
  farmers: "Agricultores",
  large: "Grande",
  medium: "Médio",
  small: "Pequeno",
  step: "Etapa",
  date: "Data",
  fileError: "Erro no arquivo",
  ProvideFileFormat: "Nota Importante: Por favor, forneça o seguinte formato (PNG/JPEG)",
  signHere: "Assine aqui",
  numOfDaysRemaining: "Número de dias restantes",
  requesterNameIsRequired: "Nome do solicitante é obrigatório",
  messageIsRequired: "A mensagem é obrigatória",
  emailIsInvalid: "O e-mail é inválido",
  emailIsRequired: "O e-mail é obrigatório",
  viewDeforestationDetails: "Ver Detalhes do Desmatamento",
  filesSucessfullyUploaded: "Arquivos enviados com sucesso",

  months: "Meses",
  days: "Dias",
  open: "Aberto",
  closed: "Fechado",
  moreInfoRequired: "Informações Adicionais Requeridas",
  publicDueDiligenceReportSettings:
    "Configurações do Relatório de Diligência Devida Pública",
  fieldRequired: "Este campo é obrigatório.",
  valueMustBeGreaterThanZero: "O valor deve ser maior que zero.",
  valueExceedsLimit:
    "O tempo de expiração não pode exceder 12 meses de acordo com as regulamentações da EUDR.",
  valueMustBeInteger: "O valor deve ser um número inteiro.",
  listOfShipments: "Lista de Envios",
  viewShipment: "Ver Envio",
  shipmentCratedSuccess: "O envio foi criado com sucesso.",
  pleaseSelectAtLeastOneDueDeligenceReport: "Por favor, selecione pelo menos um relatório de diligência devida",
  confirmation:"Confirmar",

  unsynced_record: "Registro não sincronizado",

  loadingData: "Carregando Dados...",
  markAsRead: "Marcar como Lido",

  noUploadToBlockchain: "Nenhum Upload para Blockchain",
  noDataForBlockchain: "Como não foram gerados relatórios de desmatamento para os locais de produção, não havia dados para escrever no blockchain. Se isso foi inesperado, certifique-se de que os relatórios das fazendas foram gerados corretamente nas etapas anteriores.",
  pleaseAgreeToDeclaration: "Por favor, concorde com a declaração para concluir.",
  importProductionPlaceTT: "Permite aos usuários importar dados do local de produção usando opções de upload ou download de arquivos.",
  defaultCircularGeofence: "Fazendas sem uma geofence ou sem informações sobre seu tamanho receberão uma geofence circular padrão de 4 hectares. Se o tamanho médio da fazenda for menor que 4 hectares, altere o tamanho padrão clicando no botão 'Editar' abaixo.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "De acordo com o EUDR, fazendas com menos de 4 hectares não precisam de um polígono.",
  uploadOneDeforestationAssessmentForAllFarms: "CARREGAR UMA AVALIAÇÃO DE DESMATAMENTO PARA TODAS AS FAZENDAS",
  uploadAssessment: "Carregar Avaliação",

  "timeAgo": {
    "minute": "há um minuto",
    "minutes": "há {count} minutos",
    "hour": "há uma hora",
    "hours": "há {count} horas",
    "day": "há um dia",
    "days": "há {count} dias",
    "month": "há um mês",
    "months": "há {count} meses",
    "year": "há um ano",
    "years": "há {count} anos"
  },

  faqSection: {
    createFaq: "Criar pergunta frequente",
    createTopic: "Criar tópico",
    selectTopic: "Selecionar tópico",
    faqQuestion: "Pergunta frequente",
    faqAnswer: "Resposta de perguntas frequentes",
    uploadImgVid: "Carregar imagem/vídeo do anúncio",
    disInFaq: "Exibir na seção de perguntas frequentes",
    editFaq: "Editar perguntas frequentes",
    topicName: "Nome do tema",
    parentTopic: "Tema Principal",
    editTopic: "Editar tópico",
    createSection: "Please create section first",
    createTopicFirst: "Please create topic first",
    questionReq: "A pergunta da FAQ é obrigatória",
    answerReq: "A resposta da FAQ é obrigatória",
  },

  confirmDialog: {
    assessmentBuilder: {
      delete: {
        title: "Excluir Avaliação",
        message: "Tem certeza de que deseja excluir a Avaliação?",
        confirmBtn: "Confirmar?"
      }
    },
    dueDiligenceReport: {
      delete: {
        title: "Excluir Relatório de Due Diligence EUDR",
        message: "Tem certeza de que deseja excluir o Relatório de Due Diligence EUDR?",
        confirmBtn: "Confirmar"
      }
    },
    farm: {
      delete: {
        title: "Excluir Fazenda",
        message: "Tem certeza de que deseja excluir a Fazenda?",
        confirmBtn: "Confirmar"
      }
    },
    status: {
      delete: {
        title: "Excluir Status de Desmatamento",
        message: "Você tem certeza de que deseja excluir o status de desmatamento?",
        confirmBtn: "Confirmar",
      },
    },        
  },
  seeDetails: "Ver detalhes",
  countries: "Países",
  clickHere: "Clique aqui",
  tutorials: {
    howtoCreateanAdminUser: "Como criar um usuário administrador",
    howToCreateanActivationKey: "Como criar uma chave de ativação",
    individualandBulkFarmCreation: "Criação individual e em massa de fazendas",
    creatingaDueDiligenceStatement: "Criação de uma declaração de due diligence",
    title: "Tutoriais e Guias",
    noTutorials: "Nenhum tutorial",
    addTutorialPrompt: "Por favor, adicione primeiro um tutorial ou guia.",
    videoNotAvailable: "Vídeo não disponível no seu idioma preferido.",
    watchVideo: "Assistir vídeo",
    viewTutorial: "Ver tutorial",
    // Kenyan tutorials
    creatingAndManagingUsers: "Criando e gerenciando usuários",
    howToCreateActivationKeys: "Como criar chaves de ativação",
    userRolesAndPermissions: "Funções e permissões do usuário",
    creatingAFarm: "Criando uma fazenda",
    creatingADueDiligenceStatement: "Criando uma declaração de due diligence",
    sharingStatementWithOperator: "Compartilhando declaração com operador",
    riskMitigation: "Mitigação de riscos",
    generalSettings: "Configurações gerais",
    assessmentBuilder: "Construtor de avaliações",
    bulkUserUpload: "Upload em massa de usuários",
    // Admin management
    manageTutorials: "Gerenciar Tutoriais",
    createTutorial: "Criar Tutorial",
    editTutorial: "Editar Tutorial",
    deleteTutorial: "Excluir Tutorial",
    deleteConfirmation: "Tem certeza de que deseja excluir o tutorial '{title}'?",
    createSuccess: "Tutorial criado com sucesso",
    updateSuccess: "Tutorial atualizado com sucesso",
    deleteSuccess: "Tutorial excluído com sucesso",
    createError: "Erro ao criar tutorial",
    updateError: "Erro ao atualizar tutorial",
    deleteError: "Erro ao excluir tutorial",
    saveError: "Erro ao salvar tutorial",
    loadError: "Erro ao carregar tutoriais",
    createFirstTutorial: "Crie seu primeiro tutorial para começar",
    // Form fields
    description: "Descrição",
    url: "URL",
    urlType: "Tipo de Conteúdo",
    displayOrder: "Ordem de Exibição",
    organization: "Organização",
    organizationHint: "Selecione 'Global' para tutoriais disponíveis para todas as organizações, ou escolha uma organização específica",
    userType: "Tipo de Usuário",
    userTypeHint: "Selecione qual tipo de usuários pode ver este tutorial",
    isActive: "Está Ativo",
    status: "Status",
    actions: "Ações",
    // Status options
    active: "Ativo",
    inactive: "Inativo",
    global: "Global",
    // User types
    appUsers: "Usuários do App",
    adminUsers: "Usuários Admin",
    // Validation messages
    titleRequired: "Título é obrigatório",
    titleMinLength: "Título deve ter pelo menos 3 caracteres",
    urlRequired: "URL é obrigatória para links externos",
    urlInvalid: "Por favor, insira uma URL válida",
    urlTypeRequired: "Tipo de conteúdo é obrigatório",
    fileRequired: "Arquivo é obrigatório para tutoriais baseados em arquivo",
    urlOrFileRequired: "URL ou arquivo deve ser fornecido",
    // Search functionality
    searchOrganizations: "Pesquisar organizações...",
    noOrganizationsFound: "Nenhuma organização encontrada",
    searchTutorials: "Pesquisar tutoriais...",
    selectOrganization: "Selecionar organização...",
    excludeGlobalForOrg: "Excluir tutoriais globais para organização",
    exclusionUpdateSuccess: "Configuração de exclusão de tutoriais da organização atualizada com sucesso",
    exclusionUpdateError: "Erro ao atualizar configuração de exclusão de tutoriais da organização",
    exclusionStatusLoadError: "Erro ao carregar configuração de exclusão de tutoriais da organização",
  },
  helpDesk: "Central de Ajuda",
  generateSecretKey: "Gerar Chave Secreta",
  secretKey: "Chave Secreta",
  secretKeyCopied: "Chave secreta copiada para a área de transferência",
  copied: "Copiado",
  copySecretKeyHint: "Clique no ícone de cópia para copiar a chave secreta",
}